import React from 'react';
import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import TooltipInfo from '../../common/docs/TooltipInfo';
import { description } from '../../common/utils/event_constants';

const AdvanceCollectionOptions = ({
  projectId,
  version,
  collectionId,
  collectionTitle,
  itemData,
  filename,
  deleteAllItems,
  flag,
}) => {
  return (
    <UncontrolledDropdown group className="custom-pad-right-1 pr-2" style={{ zIndex: '1100' }}>
      <DropdownToggle color="theme-warning" title="Advanced Options" className="btn-md" caret>
        <i className="wb webconnect-cogs"></i> Advance
      </DropdownToggle>
      <DropdownMenu>
        <DropdownItem>
          <Link
            to={`/2.0/collections/${version}/v/${projectId}/import-data/${collectionId}/`}
            title="Import Data"
            className="no-hover"
          >
            <i className="wb webconnect-upload"></i> Import Data
          </Link>
        </DropdownItem>
        <DropdownItem>
          <Link
            to={`/2.0/collections/${version}/v/${projectId}/dump/${collectionId}`}
            title="Export Data To File"
            className="no-hover"
          >
            <i className="wb webconnect-cloud-arrow-down" />
            &nbsp;Export Data Dump
          </Link>
        </DropdownItem>
        <DropdownItem
          title={
            collectionTitle
              ? `Delete All Records of ${collectionTitle}`
              : 'Delete Collection Records'
          }
          disabled={!flag}
          onClick={flag ? deleteAllItems : undefined}
          style={{ cursor: flag ? 'pointer' : 'not-allowed' }}
          className="theme-red"
        >
          <i className="wb webconnect-trash-regular" />
          &nbsp; Delete All Records &nbsp;
          {flag ? null : (
            <TooltipInfo
              title={description}
              headerText={`Permission Disabled!`}
              showHeader={true}
              showArrow={true}
            />
          )}
        </DropdownItem>
      </DropdownMenu>
    </UncontrolledDropdown>
  );
};

export default AdvanceCollectionOptions;
